import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-empty-state-cat',
  templateUrl: './gb-empty-state-cat.component.html',
  styleUrls: ['./gb-empty-state-cat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEmptyStateCatComponent {}
